import React, {useState, useMemo} from 'react';
import {ThemeProvider, createTheme} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AudioProcessor from './AudioProcessor';
import AuthWrapper from "./AuthWrapper";
import PromptsManagerPage from './pages/PromptsManagerPage';
import NavigationBar from './components/NavigationBar';
import Chat from './components/Chat';

const App = () => {
    const [mode, setMode] = useState('dark');

    const colorMode = useMemo(
        () => ({
            toggleColorMode: () => {
                setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
            },
        }),
        [],
    );

    const theme = useMemo(
        () =>
            createTheme({
                palette: {
                    mode,
                    ...(mode === 'light'
                        ? {
                            primary: {
                                main: '#1976d2',
                            },
                            background: {
                                default: '#f5f5f5',
                                paper: '#ffffff',
                            },
                        }
                        : {
                            primary: {
                                main: '#90caf9',
                            },
                            background: {
                                default: '#121212',
                                paper: '#1e1e1e',
                            },
                        }),
                },
            }),
        [mode],
    );

    return (
        <Router>
            <ThemeProvider theme={theme}>
                <CssBaseline/>
                <AuthWrapper>
                    <>
                        <NavigationBar colorMode={colorMode} theme={theme} />
                        <Routes>
                            <Route path="/" element={<AudioProcessor />} />
                            {/* /share-target is handled by service worker, redirect to home as fallback */}
                            <Route path="/share-target" element={<Navigate to="/" replace />} />
                            <Route path="/prompts" element={<PromptsManagerPage />} />
                            <Route path="/chat" element={<Chat />} />
                            <Route path="/chat/:conversationId" element={<Chat />} />
                        </Routes>
                    </>
                </AuthWrapper>
            </ThemeProvider>
        </Router>
    );
};

export default App;
